export default function carousel() {
	document.addEventListener("DOMContentLoaded", () => {
		const container = document.querySelector("#featured-carousel");
		const dotsEl = document.querySelector("#featured-dots");
		if (!container || !dotsEl) return;

		const slides = container.querySelectorAll(".flex-shrink-0");
		if (!slides.length) return;

		const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

		const selectDot = (dots, activeIndex) => {
			dots.forEach((dot, index) => {
				const active = index === activeIndex;
				dot.classList.toggle("active", active);
				if (active) dot.setAttribute("aria-current", "true");
				else dot.removeAttribute("aria-current");
			});
		};

		slides.forEach((_, index) => {
			const dot = document.createElement("button");
			dot.type = "button";
			dot.setAttribute("aria-label", `Go to featured article ${index + 1}`);
			dot.addEventListener("click", () => {
				slides[index].scrollIntoView({
					block: "nearest",
					behavior: reduceMotion.matches ? "auto" : "smooth",
				});
			});
			dotsEl.append(dot);
		});

		const dots = dotsEl.querySelectorAll("button");
		selectDot(dots, 0);

		let scrollTimer;
		container.addEventListener(
			"scroll",
			() => {
				window.clearTimeout(scrollTimer);
				scrollTimer = window.setTimeout(() => {
					const slideWidth = slides[0].offsetWidth + 24;
					const index = Math.round(container.scrollLeft / slideWidth);
					selectDot(dots, index);
				}, 50);
			},
			{ passive: true },
		);
	});
}
